import React from "react";
import { NavLink } from "react-router-dom";
import OverflowMenu from "../../OverflowMenu/OverflowMenu";

const Menu = (props) => {
  const { menuLinks } = props;

  return (
    <OverflowMenu dotsColor="#17b4e1">
      {menuLinks.map(({ to, label, icon, showSeparatorAbove }) => (
        <React.Fragment key={to}>
          {showSeparatorAbove && <div className="overflow-menu-separator" />}
          <NavLink
            key={to}
            to={to}
            className={({isActive}) => isActive ? "menuLinks active" : "menuLinks"}
          >
            {icon}
            <span className="link-label">{label}</span>
          </NavLink>
        </React.Fragment>
      ))}
    </OverflowMenu>
  );
};

export default Menu;
